export default __webpack_public_path__ + "static/media/gear_icn.13006608.svg";